<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-copy"></i> {{  "BUTTON.COPY-URL" | translate }}</h4>
    </div>
    <div class="modal-body">
        <div class="table-responsive">
            <table class="table-sm">
                <thead class="custom-font-size-table-header">
                <tr>
                    <th scope="col" title="#"></th>
                    <!--                    <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>-->
                    <th scope="col" title="{{'TABLE.HEADER.PERSON' | translate }}"></th>
                    <th scope="col" title="{{'TABLE.HEADER.URL' | translate }}"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let person of people; let index = index">
                    <td title="#" class="font-weight-bold">{{index + 1}}</td>
                    <!--                    <td title="{{'TABLE.HEADER.ACTION' | translate}}">-->
                    <!--                    <span class="badge {{isSigner(person)?'badge-warning text-white':'badge-default'}}">-->
                    <!--                    <i class="{{isSigner(person)? 'fas fa-signature': 'fas fa-eye'}}"></i>-->
                    <!--                        {{getOperationDescription(person) | translate}}-->
                    <!--                     </span>-->
                    <!--                    </td>-->
                    <td title="{{'TABLE.HEADER.PERSON' | translate }}">{{person.fullname | translate}}</td>
                    <td title="{{'TABLE.HEADER.URL' | translate }}" *ngIf="!isOperationComplete(person)">
                        <button class="btn-sm btn btn-success" (click)="copyToClipboard(person)"><i
                                class="fa fa-copy"></i> Copiar
                        </button>
                    </td>
                    <td title="{{'TABLE.HEADER.URL' | translate }}" *ngIf="isOperationComplete(person)">
                        No disponible
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" data-dismiss="alert" aria-label="Close" class="btn btn-outline-success"
                (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
    </div>
</div>

<app-copyclipboard *ngIf="loadingCopyClipboard"></app-copyclipboard>
